export function styleProfilePage() {
  const profilePage = document.querySelector(".sj-page-profile ");

  if (profilePage) {
    const profileHeader = profilePage.querySelector(".sj-profile-header-v2");
    profileHeader.classList.remove(...['text-center', 'large-4']);
    profileHeader.classList.add('large-12');
    profileHeader.querySelector('h1').classList.add(...['large-12', 'columns']);

    profilePage.querySelector('.sj-avatar-data').classList.remove(...['text-center', 'columns', 'large-4']);
    profilePage.querySelectorAll('.sj-table-v2 .text-center').forEach((item) => item.classList.remove('text-center'));

    let avatarButton = profilePage.querySelector('#change-avatar-button');
    let avatarContainer = profilePage.querySelector('.sj-avatar-data.sj-avatar-data-v2');

    avatarButton.querySelector('#upload-new-avatar-button').innerHTML = `
      <img src="https://astronomer.github.io/academy-theme/dist/icons/pencil.svg" alt="Update" width="24" height="24" />
    `
    avatarContainer.insertAdjacentElement('afterbegin', avatarButton);

    let badgeFrame = profilePage.querySelector('.widget-iframe');
    if (badgeFrame) {
      let badgeFrameInner = badgeFrame.contentDocument || badgeFrame.contentWindow.document;

      let badgeLinks = badgeFrameInner.querySelectorAll('.widget-table a');
      badgeLinks.forEach((item) => {
        item.style.display = 'flex';
        item.style.alignItems = 'center';
        item.style.gap = '1rem';
      })

      /** Remove expires column, which is always empty anyways */
      let badgeEmptyExpire = badgeFrameInner.querySelectorAll('td:empty');
      badgeEmptyExpire.forEach((item) => item.remove());
      badgeFrameInner.querySelector('th:nth-child(4)').remove(); /** and make sure remove corresponding table head */

      /** remove badge descriptions */
      let badgeDesc = badgeFrameInner.querySelectorAll('td:nth-child(2)');
      badgeDesc.forEach((item) => { item.remove() });
      badgeFrameInner.querySelector('th:nth-child(2)').remove();

      badgeFrame.style.marginTop = '1rem';
    }

    let headerNavigationItems = document.querySelectorAll('#header a');
    headerNavigationItems.forEach((item) => {
      item.pathname.indexOf('page') > -1 ? item.setAttribute('href', `https://academy.astronomer.io${item.getAttribute('href')}`) : '';
    })
  }
}